<ng-container *ngIf="currentPage">
  <div [ngSwitch]="currentPage">
    <app-customer-search-sidebar *ngSwitchCase="'customerSearchBasic'"></app-customer-search-sidebar>
    <app-customer-search-sidebar *ngSwitchCase="'customerSearchAdvanced'"></app-customer-search-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'customerOverview'"></app-customer-overview-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'lastContacts'"></app-customer-overview-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'merchandising'"></app-customer-overview-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'campaigns'"></app-customer-overview-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'ticketing'"></app-customer-overview-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'reminders'"></app-customer-overview-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'sepaMandates'"></app-customer-overview-sidebar>
    <app-customer-overview-sidebar *ngSwitchCase="'tixxSelectPage'"></app-customer-overview-sidebar>
    <app-imports-sidebar *ngSwitchCase="'imports'"></app-imports-sidebar>
    <app-imports-sidebar *ngSwitchCase="'importHistory'"></app-imports-sidebar>
    <app-tixx-select-sidebar *ngSwitchCase="'tixxSelectOverview'"></app-tixx-select-sidebar>
    <app-tixx-select-sidebar *ngSwitchCase="'tixxSelectEvent'"></app-tixx-select-sidebar>
    <app-tixx-select-sidebar *ngSwitchCase="'lotteryPreparation'"></app-tixx-select-sidebar>
    <app-tixx-select-sidebar *ngSwitchCase="'lotteryExecution'"></app-tixx-select-sidebar>
    <app-tixx-select-sidebar *ngSwitchCase="'lotteryDashboard'"></app-tixx-select-sidebar>
    <app-tixx-fan-portal-sidebar *ngSwitchCase="'generalSettings'"></app-tixx-fan-portal-sidebar>
    <app-tixx-fan-portal-sidebar *ngSwitchCase="'dynamicContent'"></app-tixx-fan-portal-sidebar>
    <app-reminders-sidebar *ngSwitchCase="'homeOpenReminders'"></app-reminders-sidebar>
    <app-reminders-sidebar *ngSwitchCase="'homeResolvedReminders'"></app-reminders-sidebar>
    <app-club-settings-sidebar *ngSwitchCase="'clubSettings'"></app-club-settings-sidebar>
    <app-club-settings-sidebar *ngSwitchCase="'clubAttributes'"></app-club-settings-sidebar>
    <app-club-settings-sidebar *ngSwitchCase="'clubUserList'"></app-club-settings-sidebar>
    <app-user-profile-sidebar *ngSwitchCase="'userProfile'"></app-user-profile-sidebar>
  </div>
</ng-container>
